import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    stepperWrapper: {
      marginBottom: "32px",
    },
    formCardWrapper: {
      background: theme.palette?.background?.primary,
      padding: "24px 32px !important",
      borderRadius: "12px",
      border: `1px solid ${theme.palette?.border?.primary}`,
      '& .form-builder-item-wrapper': {
        marginBottom: "20px !important",
        paddingRight: "0px !important",
        paddingLeft: "0px !important",
        '& .helper-Information': {
          borderBottom: `1px solid ${theme.palette?.border?.primary}`,
          '& .FBFieldWrapper': {
            marginBottom: "20px !important",
          },
          '& .input-wrapper': {
            marginBottom: "0px !important",
          },
        },
        '& .form-builder-item-wrapper div.helper-Information:last-of-type': {
          borderBottom: "none !important",
        },
      },
      '& .form-builder-item-wrapper.last-item': {
        marginBottom: "0px !important",
        '& .helper-Information': {
          borderBottom: "none !important",
          '& .FBFieldWrapper ': {
            marginBottom: "0px !important",
          }
        },
      },
    },
    FBFooterWrapper: {
      marginTop: '24px',
      marginBottom: '24px',
      gap: '16px',
      width: "100%",
    },
    stepperTitle: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "28px",
      color: theme.palette.text?.primary,
    }
  }
});
